<template>
  <div no-body class="lku-cp">
    <b-row>
      <b-col lg="6">
        <b-input-group>
            <b-input-group-prepend><label style="max-width: 80px;">Tgl. SKA</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tglSKA1" type="date"></b-form-input>
            <!-- <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tglSKA2" type="date"></b-form-input> -->
            <b-input-group-append><span style="min-width: 80px;" class="text-right pt-2 pr-2">Legal Parties Name</span></b-input-group-append>
            <b-form-input v-model="tblData.legalPartiesName"></b-form-input>
          </b-input-group>
      </b-col>
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend><span class="pt-2 mr-3">Title</span></b-input-group-prepend>
          <b-form-input v-model="tblData.agreement_title" ></b-form-input>
          <b-input-group-append>
            <b-button @click="search" variant="success"><i class="fa fa-search"></i> Search</b-button>
            <b-button @click="clearFilter">Clear</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table class="mb-0" ref="tblChannelPartner" 
          responsive
          striped hover small 
          style="font-size:smaller;" 

    :items="items" :fields="tblFields"
      :current-page="tblData.page" :per-page="20" :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit" @row-clicked="selectItem" :busy="isBusy">
      <template #table-busy>

        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(periodeKontrak)="data">
        {{ data.item.pks_begidate | moment('DD MMM YYYY') }} sd {{ data.item.pks_enddate | moment('DD MMM YYYY') }}
      </template>
      <template v-slot:cell(tglSKA)="data">
        {{ data.item.tglSKA | moment('DD MMM YYYY') }}
      </template>
      <template v-slot:cell(hargaTotal)="data">
        {{ data.item.hargaTotal }} 
      </template>

    </b-table>
    <b-row>
      <b-col lg="6">{{ showingLabel }}</b-col>
      <b-col lg="6">
        <b-pagination align="right" :total-rows="tblData.total" :per-page="20" v-model="tblData.page"></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-Chanelinfo {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import crud from "../../apis/crud";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  data() {
    return {
      isBusy: false,
      items: [],
      tblData: {
        tablename: 'channel-agreement',
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: 'tglSKA',
        sortDesc: false,
        tglSKA1: '',
        tglSKA2: '',
        amgUnits:'',
        legalPartiesName: '',
        agreement_title:''
      },
      tblFields: [
        {
          key: "tglSKA",
          label: "Tgl SKA",
          sortable: true
        },
        {
          key: "agreement_no",
          label: "No.Kontrak",
          sortable: true
        },
        {
          key: "legalPartiesName",
          label: "Nama Badan Hukum",
          sortable: true
        },
        {
          key: "agreement_title",
          label: "Keterangan Kontrak",
          sortable: true
        },
        {
          key: "periodeKontrak",
          label: "Periode Kontrak",
          sortable: true
        },
        // {
        //   key: "totalMedia",
        //   label: "Total Media",
        //   sortable: true
        // },
        {
          key: "hargaTotal",
          label: "Total Kontrak",
          thStyle: "width:100px",
          thClass: "text-center",
        },
      ],
      filter: null,
      channelsFilt: [{ value: '', text: '-- ALL --' }], platformsFilt: [{ value: '', text: '-- ALL --' }], YesNoAll: dropdown.YesNoAll
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, total } = tblData;
      const limit = 10;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  props: ["wfStatesId", "channelId", "platformId"],
  created: async function () {
    this.tblData.channelId = this.channelId || '';
    this.tblData.platformId = this.platformId || '';
    this.data();

    // const [platforms, chList] = await Promise.all([crud.list({
    //   tablename: 'chanel-platform',
    //   page: 1,
    //   limit: 10000,
    //   total: 0,
    //   sortBy: 'tglSKA',
    //   sortDesc: true,
    // }), crud.list({
    //   tablename: 'chanel',
    //   page: 1,
    //   limit: 10000,
    //   total: 0,
    //   sortBy: 'name',
    //   sortDesc: false,
    // })]);
    // chList.forEach(tp => {
    //   this.channelsFilt.push({ value: tp._id, text: tp.name })
    // });
    // platforms.forEach(tp => {
    //   this.platformsFilt.push({ value: tp._id, text: tp.name })
    // });


  },
  watch: {
    'tblData.platformId'(newVal) {
      this.data()
    },
    'tblData.channelId'(newVal) {
      if (newVal == this.tblData.channelId) {
        this.data()
      }
    }
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    //   this.tblData.page = 1;
    // },
    data: async function (ctx) {
      this.isBusy = true;
      this.tblData.limit = 10000;
      if (!this.tblData.sortDir) {
        // this.tblData.sortBy = 'platformName,channelName,name'
      }

      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // let str ='isdeleted=0';
      let str = '';

     
      if (this.tblData.tglSKA1) {
        str += str ? '&' : '';
        str = str + 'tglSKA=' + encodeURIComponent(moment(this.tblData.tglSKA1).format('YYYY-MM-DD'));
      }
      if (this.tblData.amgUnits) {
        str += str ? '&' : '';
        str = str + 'amgUnits=' + encodeURIComponent(this.tblData.amgUnits);
      }

      if (this.tblData.legalPartiesName) {
        str += str ? '&' : '';
        str = str + 'legalPartiesName=%' + encodeURIComponent(this.tblData.legalPartiesName)+'%';
      }

      if (this.tblData.agreement_title) {
        str += str ? '&' : '';
        str = str + 'agreement_title=%' + encodeURIComponent(this.tblData.agreement_title)+'%';
      }

      if (this.wfStatesId) {
        str += str ? '&' : '';
        str = str + 'wfStatesId=' + encodeURIComponent(this.wfStatesId);
      }

      this.tblData.customQuery = str;

      const list = await crud.list(this.tblData);
      this.isBusy = false;
      this.items = list;
      this.tblData.limit = 10;
    },

    selectItem(item, index) {
      // const idxChg = this.items.findIndex((rec)=>{
      //                 return (rec.kodegroup.startsWith(item.kodegroup) && (rec.kodegroup !==item.kodegroup));
      //             })
      // if ((idxChg || -1) > -1) {
      //   console.log ('Account punya anak tidak boleh dipilih');
      //     toastr.warn('Account punya anak tidak boleh dipilih!');
      // } else {
      this.$emit("click", item);
      // }
    },
    async search() {
      this.data();
    },
    clearFilter(){
      tblData.tglSKA1= '';
      tblData.tglSKA2= '';
      tblData.amgUnits='';
      tblData.legalPartiesName='';
      tblData.agreement_title='';
    },
    refresh() {
      this.$refs.tblChannelPartner.refresh();
    }
  }
};
</script>
